class ButtonsManager {
    constructor()
    {
        this._enabled = true;
        this._buttons = [];
    }

    register(button)
    {
        const regData = this._buttons.filter((regData) => regData.button === button).pop();
        if (regData)
        {
            return;
        }

        this._buttons.push({
            button,
            enabled: !!button.enabled
        });
    }

    unregister(button)
    {
        const regData = this._buttons.filter((regData) => regData.button === button).pop();
        if (!regData)
        {
            return;
        }

        this._buttons.splice(this._buttons.indexOf(regData), 1);
    }

    lock()
    {
        this._buttons.forEach((regData) =>
        {
            regData.enabled = !!regData.button.enabled;
            regData.button.enabled = false;
        });
    }

    unlock()
    {
        this._buttons.forEach((regData) =>
        {
            regData.button.enabled = regData.enabled;
        });
    }
}

export default new ButtonsManager();